// extracted by mini-css-extract-plugin
export default {"hackathonSection":"styles_hackathonSection__UfUIM","hackathonInfo":"styles_hackathonInfo__TQQaI"};